import React from 'react'
import styles from './styles'

export default function PreloaderDefault() {
    return (
        <main style={styles.container}>
            
        </main>
    )
}